import React, { Fragment } from 'react';
import { Row, Spinner } from 'react-bootstrap';
import styled from 'styled-components';
import CommonTable from 'components/CommonTable';
import { getStoreReport, getProvinceExcelReport } from 'network/apis/ReportingApi';
import { useQuery } from 'react-query';
import { useAdminSelector } from 'admin-app/redux/admin.store';
import StoreReportHeader from '../comps/StoreReportHeader';
import { openLink } from 'helpers/general';
import { EmptyLabel } from 'components/CommonWidgets';

const Holder = styled.div`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	width: 100%;
	margin: 0;
	padding: 0 2rem;

	div.loading {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #3876e5;
		min-height: 30rem;
	}
	  
	div.header-card {
		display: flex;
		justify-content: end;
		width: 100%;
		margin-bottom: 1.5rem;
	}
`;

const StoreReportTab = ({ currentTab = 'store-report' }) => {
	const filterState = useAdminSelector((store) => store.reportingFilter);

	const { data: storeData, refetch, isLoading } = useQuery(
		["get-store-report-tab", filterState.storesReportFilter],
		() => getStoreReport(filterState.storesReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: currentTab === 'store-report'
		}
	);	

	const cols = [
		`(${storeData?.data?.unit?.name}) موجودی`,
		'نوع نهاده',
		'نام استان',
		'ردیف'
	];

	const getList = () => {
		const inputs = storeData?.data?.inputs ?? [];
		const concentrate = storeData?.data?.concentrate;
		if (concentrate) {
			return [concentrate, ...inputs];
		} else {
			return inputs;
		}
	};
	const isListEmpty = () => getList().length < 1;

	const { refetch: fetchTableExcel } = useQuery(
		["get-table-excel", filterState.storesReportFilter],
		() => getStoreReport(filterState.storesReportFilter + 'excel=true'),
		{
			refetchOnWindowFocus: false,
			enabled: false,
			onSuccess: (data) => {
				const url = data?.list?.data?.url ?? data?.data?.url ?? '';	
				if (url) openLink(url);			
			},
		}
	);

	const { refetch: fetchProvinceExcel } = useQuery(
		["get-province-excel", filterState.storesReportFilter],
		() => getProvinceExcelReport('warehouse', '&' + filterState.storesReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: false,
			onSuccess: (data) => {
				const url = data?.data;	
				if (url) openLink(url);				
			},
		}
	);

	const downloadProvinceExcel = () => {
		fetchProvinceExcel();
	};

	const downloadTableExcel = () => {
		fetchTableExcel();
	};

	return (
		<Holder>
			{isLoading ? (
				<div className="loading">
					<Spinner animation="border" role="status" />
				</div>
			) : (
				<Fragment>
					<div className="header-card">
						<StoreReportHeader
							data={storeData?.data?.statistics}
							onDownloadTableExcel={downloadTableExcel}
							onDownloadProvinceExcel={downloadProvinceExcel}
						/>
					</div>
					{isListEmpty() ? (
						<EmptyLabel>
							رکوردی ثبت نشده است
						</EmptyLabel>
					) : (
						<CommonTable cols={cols}>
							{getList().map((item, index) => (
								<tr key={`${item?.input_id || 0}-${index}`}>
									<td>{`${item?.sum ?? 0}`.persianCurrency()}</td>
									<td>{item?.name?.name || item?.name}</td>
									<td>{filterState.selectedProvince?.label}</td>
									<td>{index + 1}</td>
								</tr>
							))}
						</CommonTable>
					)}
				</Fragment>
			)}
		</Holder>
	);
};

export default StoreReportTab;